import axios from 'axios';
// import message from "../components/message";
import useStore from '../store';
import { API_URL } from "./index";
import type { RawAxiosRequestHeaders } from 'axios';
import clearStore from "../store/clearStore";
import { showMessage } from "../lib/notification";

declare module 'axios' {
    interface AxiosRequestConfig {
        silent?: boolean;
        noAuthorization?: boolean;
        noAlert?: boolean;
    }
    // export interface AxiosResponse<T = any> extends Promise<IResponse<T>> {}
}

const TOASTER_DURATION = 10;

axios.interceptors.request.use((config) => {
    !config.silent && useStore.setState({ loading: true });
    // config.headers = {
    //     "Content-Type": "application/json",
    //     ...(config.headers as RawAxiosRequestHeaders), // <<<< this here
    // };
    if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json';
    }

    if (!config.noAuthorization && !config.headers.Authorization) {
        const state = useStore.getState();
        config.headers.Authorization = state?.auth?.token ? state?.auth?.token : undefined;
    }

    if (config.url && !config.url.startsWith("http")) {
        config.url = `${API_URL}${config.url}`;
    }

    return config;
});

axios.interceptors.response.use(
    (res) => {
        !res?.config?.silent && useStore.setState({ loading: false });
        return res;
    },
    (error) => {
        if (axios.isCancel(error)) {
            return Promise.resolve();
        }
        if (!error.config.noAlert) {
            showMessage(error?.response?.data?.message ?? 'Алдаа гарлаа');
        }
        if (error?.response?.data?.error) {
            //     message(error?.response?.data?.error?.message ?? t('messages.error', { ns: 'common' }), !!error?.response?.data?.success)
            // } else {
            //     message(t('messages.error', { ns: 'common' }), false)
            // }
        }
        if (error?.response?.status === 401) {
            useStore.setState({ auth: { token: null, roleName: '', phoneNumber: '', expiresIn: null, email: '', name: '', profilePicture: '' } })
        }
        useStore.setState({ loading: false });
        return Promise.reject(error);
    }
);
